import { defineMessages } from 'react-intl';

export default defineMessages({
  linkId: 'Board ID',
  name: 'Board Name',
  path: 'Board Path',
  title: 'Create New Board'
});
